import { Icon, IconProps } from '@chakra-ui/react'

export function PencilIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 18 18" fill="none" {...props}>
      <path
        d="M13.4167 7.02369L10.0834 3.69036M0.5 16.607L3.32031 16.2937C3.66488 16.2554 3.83717 16.2362 3.9982 16.1841C4.14108 16.1378 4.27704 16.0725 4.40241 15.9898C4.54371 15.8966 4.66629 15.7741 4.91144 15.5289L15.9167 4.52369C16.8372 3.60322 16.8372 2.11083 15.9167 1.19036C14.9962 0.269882 13.5038 0.269881 12.5834 1.19035L1.57811 12.1956C1.33296 12.4407 1.21038 12.5633 1.1172 12.7046C1.03453 12.83 0.969179 12.9659 0.922928 13.1088C0.870796 13.2699 0.851653 13.4421 0.813367 13.7867L0.5 16.607Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
